<template>
  <div>
    <riseup-header/>
    <loader v-if="isLoading"/>
    <div v-else class="discount-incomplete">
      <div class="content">
        <div>
          <img class="wait-icon" :src="require('@/assets/onboarding/icons/wait-icon.svg')">
          <div class="title">תהליך ההתחברות לדיסקונט לא הסתיים</div>
          <div class="text">הפסקת את החיבור באתר דיסקונט באמצע? אפשר לחבר כאן עם שם משתמש וסיסמה.</div>
          <div class="text"><span class="bold">ניסית לחבר חשבון משותף?</span>
            לאחר החתימה על הטפסים והקמת הרשאה בבנק, תגיע אליך הודעת sms להשלמת החיבור.
          </div>
        </div>
        <div class="button-container">
          <riseup-button :variant="'discount'" :title="'לנסות שוב באתר דיסקונט'" :size="'small'"
                         :action="() => deletePendingCredsAndEnterNewCreds('דיסקונט ישיר')"></riseup-button>
          <riseup-button :title="'לחיבור עם שם משתמש וסיסמה'" :size="'small'"
                         :action="() => deletePendingCredsAndEnterNewCreds('דיסקונט')"></riseup-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapMutations, mapActions, mapState } from 'vuex';
import Segment from '../../../../Segment';
import Loader from '../../../../base-components/Loader.vue';
import RiseupHeader from '../../../../base-components/app-header/RiseupHeader.vue';

export default {
  name: 'DiscountIncomplete',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    Loader,
    RiseupHeader,
  },
  async created() {
    Segment.trackUserGot('DiscountIncompleteShown', { query: this.$route.query });
  },
  computed: {
    ...mapState('onboardingState', ['isLoading']),
  },
  methods: {
    ...mapMutations('onboardingState', ['setPageName']),
    ...mapActions('onboardingState', ['deletePendingCreds']),
    async deletePendingCredsAndEnterNewCreds(sourceName) {
      await this.deletePendingCreds({ sourceName });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../scss/mixins';

  .discount-incomplete {
    @include white-page-frame;
    @include responsive-padding;
    height: 100%;
    text-align: center;

    .content {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .wait-icon {
        margin: 30px 0;
      }

      .title {
        font-size: 20px;
        font-weight: bold;
        color: $riseup_black;
        margin-bottom: 20px;
      }

      .text {
        font-size: 16px;
        line-height: 1.38;
        white-space: pre-wrap;
        color: $riseup_black;
        margin-bottom: 20px;

        .bold {
          font-weight: bold;
        }
      }

      .button-container {
        width: 100%;

        .riseup-button {
          width: 100%;
          margin-bottom: 20px;
          &:last-of-type {
            margin-bottom: 30px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard2/DiscountIncomplete.vue